/**
 * /voices (Voice Library) localized copy. Re-export shim over
 * /locales/{en,ht,fr,es}.json (voices key). See /locales/README.md.
 *
 * Backend-supplied strings (voice.name, voice.description, voice.region,
 * voice.use_case, voice.best_usage) stay English by design — they're
 * DB-authored and require a separate backend-side localization pass.
 */
import en from '../locales-shared/en.json'
import ht from '../locales-shared/ht.json'
import fr from '../locales-shared/fr.json'
import es from '../locales-shared/es.json'
import ptBR from '../locales-shared/pt-BR.json'
import zhHans from '../locales-shared/zh-Hans.json'

const COPY = {
  en: en.voices,
  ht: ht.voices,
  fr: fr.voices,
  es: es.voices,
  'pt-BR': ptBR.voices,
  'zh-Hans': zhHans.voices,
}

export default COPY
